"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const IconButton_1 = __importDefault(require("@material-ui/core/IconButton"));
const ListItemIcon_1 = __importDefault(require("@material-ui/core/ListItemIcon"));
const ListItemText_1 = __importDefault(require("@material-ui/core/ListItemText"));
const Menu_1 = __importDefault(require("@material-ui/core/Menu"));
const MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
const TableBody_1 = __importDefault(require("@material-ui/core/TableBody"));
const TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
const TableHead_1 = __importDefault(require("@material-ui/core/TableHead"));
const TablePagination_1 = __importDefault(require("@material-ui/core/TablePagination"));
const TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
const TableSortLabel_1 = __importDefault(require("@material-ui/core/TableSortLabel"));
const Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
const MoreVert_1 = __importDefault(require("@material-ui/icons/MoreVert"));
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importStar(require("react"));
const lib_1 = require("../../lib");
const Table_styles_1 = __importDefault(require("./Table.styles"));
const MenuAction = react_1.forwardRef(({ name, label, color, onClick, actionTarget, closeActionsMenu, Icon }, ref) => {
    if (name === 'divider')
        return react_1.default.createElement(Divider_1.default, null);
    if (!onClick || !closeActionsMenu || !Icon)
        return null;
    return (react_1.default.createElement(MenuItem_1.default, { ref: ref, style: { color: color || 'default' }, onClick: () => {
            onClick(actionTarget);
            closeActionsMenu();
        } },
        react_1.default.createElement(ListItemIcon_1.default, null,
            react_1.default.createElement(Icon, null)),
        react_1.default.createElement(ListItemText_1.default, { primary: label })));
});
class DVKTable extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            actionsMenuAnchor: undefined,
            actionTarget: undefined,
        };
        this.createSortHandler = (property) => () => {
            this.handleSort(property);
        };
        this.handleSort = (property) => {
            const { onPaginationSortUpdate, sort, pagination } = this.props;
            if (!onPaginationSortUpdate)
                return;
            const { orderBy, order } = sort || { orderBy: '', order: '' };
            const newOrder = orderBy === property && order === 'asc' ? 'desc' : 'asc';
            onPaginationSortUpdate(pagination ? Object.assign(Object.assign({}, pagination), { page: 0 }) : undefined, { order: newOrder, orderBy: property });
        };
        this.handleChangePage = (_event, page) => {
            const { onPaginationSortUpdate, sort, pagination } = this.props;
            if (!onPaginationSortUpdate || !pagination)
                return;
            onPaginationSortUpdate(Object.assign(Object.assign({}, pagination), { page }), sort);
        };
        this.closeActionsMenu = () => this.setState({ actionsMenuAnchor: undefined, actionTarget: undefined });
    }
    renderCell(row, column) {
        const { classes } = this.props;
        if (column.type === 'imageBase64') {
            const imgData = lib_1.deepGet(row, column.name);
            return (react_1.default.createElement(TableCell_1.default, { key: column.name, className: clsx_1.default(classes.thumbnailWrapper, classes.thumbnailRowWrapper) }, imgData && (react_1.default.createElement("img", { className: classes.thumbnail, src: imgData, alt: `${row.id}-${column.name}` }))));
        }
        const value = lib_1.deepGet(row, column.name);
        return (react_1.default.createElement(TableCell_1.default, { key: column.name, align: column.type === 'number' ? 'right' : 'left' }, column.project ? column.project(value) : value));
    }
    renderActions(row) {
        const { classes } = this.props;
        return (react_1.default.createElement(TableCell_1.default, { className: classes.actionsCol },
            react_1.default.createElement(IconButton_1.default, { className: classes.actionsButton, "aria-controls": "actions-menu", "aria-haspopup": "true", onClick: (event) => {
                    event.stopPropagation();
                    this.setState({
                        actionsMenuAnchor: event.currentTarget,
                        actionTarget: row,
                    });
                } },
                react_1.default.createElement(MoreVert_1.default, null))));
    }
    renderTable() {
        const { classes, className, rows, columns, onRowClick, actions, pagination, sort, total, } = this.props;
        const emptyRows = (pagination &&
            total &&
            pagination.rowsPerPage -
                Math.min(pagination.rowsPerPage, total - pagination.page * pagination.rowsPerPage)) ||
            0;
        return (react_1.default.createElement(core_1.Table, { className: className },
            react_1.default.createElement(TableHead_1.default, null,
                react_1.default.createElement(TableRow_1.default, null,
                    columns.map((column) => (react_1.default.createElement(TableCell_1.default, { key: column.name, align: column.type === 'number' ? 'right' : 'left', sortDirection: sort && sort.orderBy === column.name ? sort.order : false }, sort !== undefined && !column.noSort ? (react_1.default.createElement(Tooltip_1.default, { title: "Sort", placement: column.type === 'number' ? 'bottom-end' : 'bottom-start', enterDelay: 300 },
                        react_1.default.createElement(TableSortLabel_1.default, { active: (sort && sort.orderBy === column.name) || undefined, direction: (sort && sort.order) || undefined, onClick: this.createSortHandler(column.name) }, column.label))) : (react_1.default.createElement(react_1.default.Fragment, null, column.label))))),
                    actions && react_1.default.createElement(TableCell_1.default, { className: classes.actionsCol }))),
            react_1.default.createElement(TableBody_1.default, null,
                rows.map((row) => (react_1.default.createElement(TableRow_1.default, { key: row.id || row.syntheticId, hover: !!onRowClick, style: { cursor: onRowClick ? 'pointer' : 'inherit' }, onClick: () => onRowClick && onRowClick(row) },
                    columns.map((column) => this.renderCell(row, column)),
                    actions && this.renderActions(row)))),
                emptyRows > 0 && (react_1.default.createElement(TableRow_1.default, { style: { height: 48 * emptyRows } },
                    react_1.default.createElement(TableCell_1.default, { colSpan: columns.length + (actions ? 1 : 0) }))))));
    }
    renderPagination() {
        const { pagination, total, classes } = this.props;
        if (!total || !pagination)
            return;
        const { rowsPerPage, page } = pagination;
        return (react_1.default.createElement(TablePagination_1.default, { component: "div", backIconButtonProps: { 'aria-label': 'Previous Page' }, nextIconButtonProps: { 'aria-label': 'Next Page' }, rowsPerPageOptions: [rowsPerPage], count: total, rowsPerPage: rowsPerPage, page: page, onChangePage: this.handleChangePage, classes: { root: classes.pagination } }));
    }
    render() {
        const { actionsMenuAnchor, actionTarget } = this.state;
        const { total, actions } = this.props;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            this.renderTable(),
            total && this.renderPagination(),
            actions && (react_1.default.createElement(Menu_1.default, { id: "actions-menu", anchorEl: actionsMenuAnchor, keepMounted: true, open: !!actionsMenuAnchor, onClose: this.closeActionsMenu }, actions.map((action) => (react_1.default.createElement(MenuAction, Object.assign({}, action, { key: action.name, closeActionsMenu: this.closeActionsMenu, actionTarget: actionTarget }))))))));
    }
}
exports.default = core_1.withStyles(Table_styles_1.default)(DVKTable);
//# sourceMappingURL=index.js.map